
import { Component, Prop, Vue } from 'vue-property-decorator'
import { debounce } from '~/lib/utils/utils'

@Component({
  name: 'InputText'
})
export default class InputTextBasic extends Vue {
  @Prop({ type: String, default: '' }) placeholder!: string
  @Prop({ type: Function, default: val => val }) format!: (str: string) => string
  @Prop({ type: Boolean, default: false }) error!: boolean
  @Prop({ type: String }) name!: string
  @Prop({ type: String }) value!: string
  @Prop({ type: String, default: 'text' }) type!: string
  @Prop({ type: Boolean, default: false }) disabled!: boolean

  placeholderDynamic = ''

  mounted() {
    this.togglePlaceholder(this.placeholder)
  }

  input(ev) {
    const valueFormat = this.format(ev.target.value)
    ev.target.value = valueFormat
    this.$emit('input', valueFormat)

    debounce(() => {
      this.$emit('validate')
    }, 2000)
  }

  togglePlaceholder(placeholder: string) {
    this.placeholderDynamic = placeholder
  }
}
